import React from 'react';

const ShippingFlow = () => {
  return (
    <div className="w-full ">
      <div className="flex flex-wrap justify-between items-start gap-4">
        <div className="text-center">
          <p className="text-gray-800 font-medium">Chennai</p>
          <p className="text-gray-500 text-sm">Pickup Point</p>
        </div>

        <div className="text-center">
          <p className="text-gray-800 font-medium">Ennore</p>
          <p className="text-gray-500 text-sm">Loading Point</p>
        </div>

        <div className="text-center">
          <p className="text-gray-800 font-medium">Ennore</p>
          <p className="text-gray-500 text-sm">Clearance Point</p>
        </div>

        <div className="text-center">
          <p className="text-gray-800 font-medium">Ennore</p>
          <p className="text-gray-500 text-sm">Unloading Point</p>
        </div>
      </div>
    </div>
  );
};

export default ShippingFlow;